// extracted by mini-css-extract-plugin
module.exports = {"banner_con":"style_banner_con__Xe0x7","banner_title":"style_banner_title__SipUv","banner_desc":"style_banner_desc__2mqTB"};